{
  "links" : {
    "triggerLinksDescription" : "liens SMS réservation. Veuillez fournir le texte que vous souhaitez traduire Gmail",
    "enterName" : "Entrer le nom",
    "enterLinkURL" : "Saisissez une URL",
    "save" : "archiver",
    "cancel" : "Annuler",
    "delete" : "Supprimer",
    "aboutToDeleteLink" : "vous proposez de supprimer le lien ${deleteRowName} . Le lien supprimé ne peut pas être restauré, voulez-vous vraiment continuer ?",
    "noTriggerLinksFound" : "Aucun lien de paiement n'a été trouvé",
    "getStartedByAddingNewTriggerLinks" : "Commencez par ajouter de nouveaux liens",
    "newTriggerLink" : "nouveau lien",
    "searchNoMatch" : "Votre recherche n'a donné aucun résultat.",
    "link" : "lien",
    "addLink" : "ajouter un lien",
    "linkURL" : "URL",
    "name" : "Nom",
    "pleaseEnterNonEmptyLinkName" : "Veuillez saisir un nom de lien non vide",
    "pleaseEnterURL" : "Veuillez saisir une URL",
    "actions" : "activités",
    "linkKey" : "clé de lien",
    "keyCopied" : "clé copié"
  }
}
